import React from 'react';

const VendorDashboard = () => {
  return (
    <div>
      <h1>Architecture Dashboard</h1>
      <p>Welcome to the Architecture dashboard!</p>
    </div>
  );
};

export default VendorDashboard;